import React from 'react';
import { Grid, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'; // Grid2 in mui 6
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';
import ACHEditAccount from './ACHEditAccount';
import { AccountBox } from './AccountBox';

// Render ACH account and allow open editting page and deletion of account
const ACHAccount = (props) => {
  const { account, updateAccount, deleteAccount, editOption = true, deleteOption = false } = props;
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);

  const handleClickEdit = () => {
    setIsEditMode(true);
  };

  const handleDeleteAccount = () => {
    setIsDeleteDialogOpen(false);
    deleteAccount(account.paymentMethodId);
  };

  const handleCloseDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  return (
    <>
      {!isEditMode ? (
        <AccountBox elevation={3}>
          <Grid container rowSpacing={1} justifyContent={'space-between'} alignItems={'center'}>
            <Grid item xs={8} md={9}>
              {`${account.bankName || 'N/A'} - ${account.accountType || 'N/A'} - ${account.maskedValue || '****'}`}
            </Grid>
            {editOption && (
              <Grid item>
                <IconButton onClick={() => handleClickEdit()}>
                  <EditIcon />
                </IconButton>
              </Grid>
            )}

            {deleteOption && (
              <>
                <Grid item>
                  <IconButton onClick={() => setIsDeleteDialogOpen(true)}>
                    <DeleteIcon />
                  </IconButton>
                  <Dialog open={isDeleteDialogOpen} onClose={handleCloseDialog}>
                    <DialogTitle>Delete Account</DialogTitle>
                    <DialogContent>
                      Are you sure you want to delete this bank account? This action cannot be undone.
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleDeleteAccount} autoFocus>
                        Delete
                      </Button>
                      <Button onClick={handleCloseDialog}>Cancel</Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
              </>
            )}
          </Grid>
        </AccountBox>
      ) : (
        <ACHEditAccount account={account} updateAccount={updateAccount} onDone={() => setIsEditMode(false)} />
      )}
    </>
  );
};

ACHAccount.propTypes = {
  account: PropTypes.object.isRequired,
  updateAccount: PropTypes.func,
  deleteAccount: PropTypes.func,
  editOption: PropTypes.bool,
  deleteOption: PropTypes.bool,
};

export default ACHAccount;
